interface Props {
  header: string;
  text: string;
  button: JSX.Element;
}
export const TicketContainer = ({ button, header, text }: Props) => (
  <section className='grid grid-cols-1 md:grid-cols-3 hover:bg-white hover:bg-opacity-40 px-4 py-4'>
    <div className='col-span-2'>
      <h4 className='font-bold text-yellow-900 text-center md:text-left'>
        {header}
      </h4>
      <p className='text-center md:text-left'>{text}</p>
    </div>
    {button}
  </section>
);
